import createModule from "modules/createModule"
import view from "./view"
import { getDefaultMetricUnits, getMetricUnitOptions, getSupportedMetrics } from "./selectors"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import withUrlParams from "hocs/withUrlParams"

export default withUrlParams(createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
  }),
  required: ["account"],
  data: [{
    resource: "userDefaultMetricUnits",
    url: ({ accountId }) => {
      if (!accountId) {
        return null
      }

      return {
        id: `userDefaultMetricUnits-${accountId}`,
        url: "/api/users/me/preferences",
        payload: {
          items: [{
            type: "defaultMetricUnits",
            key: accountId,
            accountId,
          }],
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    defaultUnits: getDefaultMetricUnits(state, props),
    supportedMetrics: getSupportedMetrics(state, props),
    options: getMetricUnitOptions(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
    closeDialog: DialogCreators.close,
  },
}))
